import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';

@Component({
  selector: 'app-review-b',
  templateUrl: './review-b.component.html',
  styleUrls: ['./review-b.component.css']
})
export class ReviewBComponent implements OnInit {

  @ViewChild('targetBtn') targetBtn!: ElementRef;
  @ViewChild('followerDiv') followerDiv!: ElementRef;

ngOnInit(): void {
  
}

  
}



